import React from 'react'

import styled from 'styled-components'

import Flex from './layouts/Flex'

import { useDispatch, useSelector } from 'react-redux'

import { setActiveTab } from '../store/actions/tabActions'

const Tabs = ({
  tabList,
  tabGroup,
  margin = '1rem 0 0.75rem 0',
  onBeforeTabClick = () => {},
}) => {
  const dispatch = useDispatch()

  const { activeTab } = useSelector((state) => state.tabs)

  const handleTabClick = (tab) => {
    onBeforeTabClick()
    dispatch(setActiveTab({ group: tabGroup, name: tab }))
  }

  return (
    <Flex margin={margin} gap="0.75rem" items="center">
      {tabList.map((tab, i) => (
        <Tab
          key={i}
          onClick={() => handleTabClick(tab.value)}
          className={activeTab[tabGroup] === tab.value ? 'active' : ''}
        >
          {tab.name}
        </Tab>
      ))}
    </Flex>
  )
}

const Tab = styled.div`
  font-size: 0.875rem;
  font-weight: 300;
  color: #676e92;
  padding: 0.2rem 0;
  cursor: pointer;

  &.active,
  &:hover {
    color: #1a1a1a;
    border-bottom: 1px solid #1877f2;
    cursor: pointer;
  }
`

export default Tabs
